import type { EditableQuestion } from '@/components/questions/types'

/** A question the respondent can actually answer: it has text, and choice
 *  kinds have at least one non-empty option (scale/nps options are generated). */
export const isAskable = (q: EditableQuestion) =>
  q.text.trim().length > 0 &&
  (q.kind === 'text' || q.kind === 'scale' || q.kind === 'nps' || q.options.some((o) => o.text.trim()))

/** Questions a respondent will actually be asked, in order: the builder
 *  questions followed by the metryczka (demographics) fields. This is the single
 *  source of truth for "how many questions" — the launch payload, the
 *  ready-to-launch summary count, and the respondent preview all use it. */
export const askableQuestions = (
  questions: EditableQuestion[],
  demographics: EditableQuestion[],
): EditableQuestion[] => [...questions, ...demographics].filter(isAskable)
